// Application copy content constants
export const APP_COPY = {
  // Header/Navigation
  header: {
    title: "St. Dominic's Bluff",
    subtitle: "Welcome to our community",
    nav: {
      home: "Home",
      retreats: "Retreats",
      contact: "Contact Us"
    }
  },

  // Home page content
  home: {
    hero: {
      title: "Welcome to St. Dominic's House of Prayer",
      subtitle: "Discover our beautiful community",
      cta: "Learn More"
    },
    mainDescription: {
      title: "A Place of Retreat and Reflection",
      content: "We are situated on the Bluff in Durban. We offer retreats to Christians who wish to avail themselves of our facilities. Please feel free to contact us, should you require a venue for your retreat.",
      venueDetails: "St Dominic's is an ideal venue for smaller groups and is close to the sea. It is a wonderful opportunity 'to press the pause button', and take a break from the business and routine of the stress of life, and to spend quality time with your God. Kindly contact the Secretary info@stdominicsbluff.org.za to make the necessary arrangements.",
      atmosphere: "We aim to create a balance between hospitality and a Prayerful atmosphere."
    },
    features: {
      title: "What We Offer",
      items: [
        {
          title: "1-day retreat, weekend retreats, workshops",
          description: "Click for more details"
        },
        {
          title: "Directed and preached retreats",
          description: "Click for more details"
        },
        {
          title: "Online retreats, spiritual direction or any specific retreat",
          description: "Click for more details"
        }
      ]
    },
    facilities: {
      title: "Our Facilities",
      description: "Everything you need for a peaceful retreat",
      items: [
        {
          title: "Layout",
          description: "Centre, bedrooms, conference room, Chapel"
        },
        {
          title: "Meals & Refreshments",
          description: "Meals offered, tea/coffee. We do our best to accommodate any medical dietary requirements you might have. We would need to know this, when you make your booking."
        },
        {
          title: "Location",
          description: "Situated on the Bluff in Durban, close to the sea"
        }
      ]
    }
  },

  // About page content
  about: {
    title: "About St. Dominic's Bluff",
    description: "Learn more about our community and what makes us special.",
    sections: [
      {
        title: "Our Story",
        content: "St. Dominic's Bluff has been a cornerstone of our community for generations."
      },
      {
        title: "Our Mission",
        content: "We strive to create a welcoming environment for all residents."
      },
      {
        title: "Our Values",
        content: "Community, respect, and excellence guide everything we do."
      }
    ]
  },

  // Services page content
  services: {
    title: "Our Services",
    description: "Explore the services we provide to our community.",
    services: [
      {
        title: "Community Events",
        description: "Regular events and activities for residents"
      },
      {
        title: "Maintenance",
        description: "Professional maintenance and upkeep services"
      },
      {
        title: "Security",
        description: "24/7 security and safety measures"
      }
    ]
  },

  // Contact page content
  contact: {
    title: "Contact Us",
    description: "Get in touch with us for any questions or concerns about our retreats and facilities.",
    form: {
      name: "Full name",
      email: "Email address",
      phone: "Contact number",
      city: "City",
      message: "Your Message",
      submit: "Send Message"
    },
    info: {
      address: "10 Baudry Rd, Ocean View, Bluff, 4052",
      phone: "031 467 3721",
      mobile: "079 538 0846",
      email: "info@stdominicsbluff.com",
      officeHours: "Mon-Fri 8am-4pm, Sat 8am-12pm"
    }
  },

  // Footer content
  footer: {
    copyright: "© 2025 St. Dominic's House of Prayer. All rights reserved.",
    links: {
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      sitemap: "Sitemap"
    }
  },

  // Common UI elements
  common: {
    loading: "Loading...",
    error: "Something went wrong. Please try again.",
    notFound: "Page not found",
    backToHome: "Back to Home"
  }
};

// Form validation messages
export const VALIDATION_MESSAGES = {
  required: "This field is required",
  email: "Please enter a valid email address",
  minLength: (min) => `Must be at least ${min} characters`,
  maxLength: (max) => `Must be no more than ${max} characters`
};

// Success/Error messages
export const MESSAGES = {
  success: {
    formSubmitted: "Thank you! Your message has been sent successfully. We'll get back to you soon.",
    profileUpdated: "Profile updated successfully."
  },
  error: {
    formSubmission: "Sorry, we couldn't send your message. Please try again or contact us directly.",
    networkError: "Network error. Please check your connection and try again."
  }
}; 